<template>
  <div class="ft-admin">
    <div class="ft-shell">
      <aside class="ft-sidebar">
        <div class="ft-sidebar-brand">
          <div class="ft-logo-mark">TF</div>
          <div>
            <div class="ft-brand-title">TEF Admin</div>
            <div class="ft-brand-subtitle">Blog, Career, Factory Request &amp; Seminar</div>
          </div>
        </div>

        <nav class="ft-sidebar-nav">
          <router-link to="/admin/blog" :class="{ 'ft-active': $route.path.startsWith('/admin/blog') }">
            <i class="fas fa-newspaper"></i> Blog
          </router-link>
          <router-link to="/admin/careers" :class="{ 'ft-active': $route.path.startsWith('/admin/careers') }">
            <i class="fas fa-briefcase"></i> Career
          </router-link>
          <router-link to="/admin/factory-request" :class="{ 'ft-active': $route.path.startsWith('/admin/factory-request') }">
            <i class="fas fa-clipboard"></i> Factory Request
          </router-link>
          <router-link to="/admin/seminar" :class="{ 'ft-active': $route.path.startsWith('/admin/seminar') }">
            <i class="fas fa-bullhorn"></i> Seminar
          </router-link>
        </nav>

        <div class="ft-sidebar-footer">
          <button @click="logout"><i class="fas fa-sign-out-alt"></i> Logout</button>
        </div>
      </aside>

      <div class="ft-main-area">
        <div class="ft-topbar">
          <div>
            <h1 class="ft-topbar-title">{{ pageTitle }}</h1>
            <div class="ft-topbar-sub">PT Tokki Engineering and Fabrication</div>
          </div>
          <div class="ft-avatar">{{ initials }}</div>
        </div>
        <div class="ft-container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/services/adminAuth.service';
import adminAuthHeader from '@/helpers/adminAuthHeader';
import '@/assets/css/ft-admin.css';

export default {
  name: 'AdminLayout',
  data() {
    return {
      userName: '',
    };
  },
  computed: {
    pageTitle() {
      const titles = {
        'admin.blog': 'Blog Posts',
        'admin.blog.create': 'New Blog Post',
        'admin.blog.edit': 'Edit Blog Post',
        'admin.careers': 'Job Openings',
        'admin.careers.create': 'New Job Opening',
        'admin.careers.edit': 'Edit Job Opening',
        'admin.factoryRequest': 'Factory Request',
        'admin.seminar': 'Seminar Invitations',
      };
      return titles[this.$route.name] || 'Dashboard';
    },
    initials() {
      if (!this.userName) return 'A';
      return this.userName.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase();
    },
  },
  mounted() {
    auth.me().then((response) => {
      this.userName = response.data.data.name;
    }).catch(() => {});
  },
  methods: {
    logout() {
      auth.logout().catch(() => {});
      adminAuthHeader.unset();
      this.$router.push('/login');
    },
  },
};
</script>
